import React from 'react';
import { Form, FormProps } from '../../common/components/form/form.component';
import {
  Input,
  InputPublicProps,
} from '../../common/components/input/input.component';
import { PaperSizes, TemplatingEngines } from '../../../models/data.models';
import { getEnumValues } from '../../../utils/helper.utils';
import {
  GraphqlField,
  HtmlField,
  JsonField,
} from '../../common/components/input/ace-input.component';

export const DocumentTemplateForm = ({
  children,
  onSubmit,
  initialValues,
  id,
  validationSchema,
}: FormProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      id={id}
      validationSchema={validationSchema}
    >
      {children}
    </Form>
  );
};

DocumentTemplateForm.BodyHtmlTemplate = (props: InputPublicProps) => {
  return (
    <HtmlField
      name={'bodyHtmlTemplate'}
      label={'Body HTML Template'}
      {...props}
    />
  );
};

DocumentTemplateForm.BodyTextTemplate = (props: InputPublicProps) => {
  return (
    <HtmlField
      name={'bodyTextTemplate'}
      label={'Body Text Template'}
      {...props}
    />
  );
};
DocumentTemplateForm.CustomPaperSize = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'customPaperSize'}
      label={'Custom Size'}
      placeholder={'width,height'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.CreatedUserId = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'createdUserId'}
      label={'Created User Id'}
      placeholder={'Created User Id'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.Description = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'description'}
      label={'Description'}
      placeholder={'Description'}
      required={true}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.DocumentTemplateType = ({
  onChange,
  options,
  name = 'documentTemplateType',
  id = 'documentTemplateType',
  placeholder = 'Document Template Type',
  required = true,
  multiple = false,
  disabled = false,
  header,
  defaultValue = '',
  readonly,
}: InputPublicProps) => {
  return (
    <Input
      readonly={readonly}
      type={'react-select'}
      name={name}
      id={id}
      header={header}
      placeholder={placeholder}
      required={required}
      defaultValue={defaultValue}
      multiple={multiple}
      disabled={disabled}
      onChange={onChange}
      options={options}
    />
  );
};
DocumentTemplateForm.FileNameTemplate = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'fileNameTemplate'}
      label={'File Name Template'}
      placeholder={'File Name Template'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};

DocumentTemplateForm.GqlQuery = (props: InputPublicProps) => {
  return <GraphqlField name={'gqlQuery'} label={'Gql Query'} {...props} />;
};

DocumentTemplateForm.GqlVariables = (props: InputPublicProps) => {
  return (
    <JsonField
      name={'gqlVariables'}
      label={'Gql Variables'}
      {...props}
      output={'object'}
    />
  );
};

DocumentTemplateForm.IsDefault = ({
  className,
  defaultValue,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'isDefault'}
      label={'Is Default'}
      placeholder={'Is Default'}
      required={true}
      type={'checkbox'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
      defaultValue={defaultValue}
    />
  );
};
DocumentTemplateForm.IsInactive = ({
  className,
  defaultValue,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'isInactive'}
      label={'Is Inactive'}
      placeholder={'Is Inactive'}
      required={true}
      type={'checkbox'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
      defaultValue={defaultValue}
    />
  );
};
DocumentTemplateForm.Margins = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'margins'}
      label={'Margins'}
      placeholder={'top,right,bottom,left'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.Name = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'name'}
      label={'Name'}
      placeholder={'Name'}
      required={true}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.TemplatingEngine = (props: InputPublicProps) => {
  return (
    <Input
      name={'templatingEngine'}
      type={'react-select'}
      options={getEnumValues(TemplatingEngines)}
      {...props}
    />
  );
};

DocumentTemplateForm.PaperSize = ({
  className,
  style,
  size,
  disabled,
  onChange,
  name,
  id,
  header,
  placeholder,
  defaultValue,
  required,
  readonly,
}: InputPublicProps) => {
  return (
    <Input
      readonly={readonly}
      type={'react-select'}
      name={name}
      id={id}
      header={header}
      placeholder={placeholder}
      required={required}
      defaultValue={defaultValue}
      multiple={false}
      disabled={disabled}
      onChange={onChange}
      options={getEnumValues(PaperSizes)}
    />
  );
};
DocumentTemplateForm.SubjectTemplate = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'subjectTemplate'}
      label={'Subject Template'}
      placeholder={'Subject Template'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
DocumentTemplateForm.UpdatedUserId = ({
  className,
  style,
  size,
  disabled,
}: InputPublicProps) => {
  return (
    <Input
      name={'updatedUserId'}
      label={'Updated User Id'}
      placeholder={'Updated User Id'}
      required={false}
      type={'text'}
      className={className}
      style={style}
      disabled={disabled}
      size={size}
    />
  );
};
